var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M22 7.74995H9.75V1.94995H16.19C19.83 1.94995 22 4.11995 22 7.74995Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          d: "M22 16.25C21.95 19.82 19.79 21.95 16.19 21.95H9.75V16.25H22Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M8.25 1.94995V21.95H7.81C4.17 21.95 2 19.78 2 16.14V7.75995C2 4.11995 4.17 1.94995 7.81 1.94995H8.25Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: { d: "M22 9.25H9.75V14.75H22V9.25Z", fill: _vm.color }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }